<template>
  <div id="app">
    <Header route-value="6" ref="header"></Header>
    <content class="blog_content">
      <!-- 标题区域 -->
      <div class="blog_title_wrap">
        <h1 class="main_title">Printbelle Blog</h1>
        <p class="sub_title">E-commerce tips and insights.</p>
      </div>
      <!-- 横向导航栏 + 语言切换 -->
      <div class="nav-wrapper" v-if="navList.length>0">
        <div
          class="nav-arrow left"
          v-if="showLeftArrow"
          @click="scrollNav('left')"
        >
          ‹
        </div>
        <div
          class="blog_nav-scroll"
          ref="navScrollRef"
          @scroll="onNavScroll"
        >
          <div
            v-for="item in navList"
            :key="item.id"
            class="nav_item"
            :class="{ active: activeNav === item.id }"
            @click="handleNavClick(item.id)"
          >
            <span>{{ lang === 'us' ? item.name : item.nameVn }}</span>
          </div>
        </div>
        <div
          class="nav-arrow right"
          v-if="showRightArrow"
          @click="scrollNav('right')"
        >
          ›
        </div>
        <!-- 语言切换 -->
        <div class="lang_switch">
          <span class="lang_bg">
            <span
              class="lang_btn"
              :class="{ active: lang === 'us' }"
              @click="switchLang('us')"
            >US</span>
            <span
              class="lang_btn"
              :class="{ active: lang === 'vi' }"
              @click="switchLang('vi')"
            >VN</span>
          </span>
        </div>
      </div>
      <!-- 博客列表 -->
      <a-spin :spinning="spinning">
        <div class="blog_list" v-if="blogList.length">
          <div
            v-for="item in blogList"
            :key="item.id"
            class="blog_item"
            @click="goToBlogDetail(item)"
          >
            <div class="blog_img_wrap">
              <img :src="item.icon | imgFilter" alt="blog cover"/>
            </div>
            <h3 class="blog_title" :title="getBlogText(item, 'title')">
              {{ getBlogText(item, 'title') }}
            </h3>
            <p class="blog_desc" v-html="getBlogText(item, 'desc')"></p>
            <span class="blog_date">{{ formatDate(item.publishTime) }}</span>
          </div>
        </div>
        <!-- 空状态 -->
        <div class="empty_box" v-else>
          <img src="@/assets/empty.png" alt="no data"/>
        </div>
      </a-spin>
      <!-- 分页 -->
      <div class="pagination" v-if="blogList.length">
        <a-pagination
          :current="queryParams.pageNum"
          :total="total"
          :page-size="9"
          @change="handlePageChange"
          @show-size-change="handlePageSizeChange"
          :item-render="itemRender"
        />
      </div>
      <!-- 底部 -->
      <div class="bottom-cta">
        <p class="cta-subtitle">Scale your POD business with automation.</p>
        <h3 class="cta-title">Let’s build it together</h3>
        <a :href="href" class="cta-btn" target="_blank">Get Started</a>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import {get} from '@/api'
import {formatDate} from '@/utils/utils'

export default {
  name: 'Blog',
  components: {Header, Footer},
  data () {
    return {
      href: process.env.VUE_APP_MERCHANT + 'user/register',
      spinning: false,
      lang: 'us',
      activeNav: 'all',
      categoryId: 'all',
      queryParams: {
        pageNum: 1,
        pageSize: 9
      },
      total: 0,
      showLeftArrow: false,
      showRightArrow: false,
      navList: [{name: 'All Posts', nameVn: 'Tất cả', id: 'all'}],
      blogList: []
    }
  },
  watch: {
    '$route.params.lang' (lang) {
      this.lang = lang || 'us'
    }
  },
  mounted () {
    this.lang = this.$route.params.lang || 'us'
    this.initPage()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkArrowVisible)
  },
  methods: {
    formatDate,
    itemRender (page, type, originalElement) {
      if (type === 'prev') {
        return <img class="pagination-arrow" src={require('../assets/icon/left-arrow.png')}/>
      }
      if (type === 'next') {
        return <img class="pagination-arrow" src={require('../assets/icon/right-arrow.png')}/>
      }
      return originalElement
    },
    initPage () {
      window.scrollTo(0, 0)
      this.getBlogCategoryList()

      this.$nextTick(() => {
        this.checkArrowVisible()
        window.addEventListener('resize', this.checkArrowVisible)
      })
    },

    handleNavClick (id) {
      this.activeNav = id
      this.categoryId = id
      this.queryParams.pageNum = 1
      this.getBlogList()
      this.$nextTick(() => {
        this.checkArrowVisible()
      })
    },

    checkArrowVisible() {
      this.$nextTick(() => {
        const el = this.$refs.navScrollRef
        if (!el) return

        el.offsetHeight
        const totalWidth = el.scrollWidth
        const visibleWidth = el.clientWidth
        const scrollLeft = el.scrollLeft

        this.showLeftArrow = scrollLeft > 10
        this.showRightArrow = totalWidth > visibleWidth + 10 && scrollLeft < totalWidth - visibleWidth - 10
      })
    },

    onNavScroll () {
      this.checkArrowVisible()
    },

    scrollNav (direction) {
      const el = this.$refs.navScrollRef
      if (!el) return
      const step = 200
      el.scrollTo({
        left: el.scrollLeft + (direction === 'left' ? -step : step),
        behavior: 'smooth'
      })
      this.$nextTick(() => {
        this.checkArrowVisible()
      })
    },

    switchLang (lang) {
      if ((this.$route.params.lang || 'us') === lang) return
      this.$router.replace('/blog/' + lang).then(() => {
        this.$nextTick(() => {
          this.checkArrowVisible()
        })
      })
    },

    getBlogCategoryList () {
      get('/index/message/blog/category/all')
        .then(res => {
          const list = res.data || []
          this.navList = [{name: 'All Posts', nameVn: 'Tất cả', id: 'all'}, ...list]
          this.getBlogList(false)
          this.$nextTick(() => {
            this.checkArrowVisible()
          })
        })
        .catch(err => console.error('获取分类失败：', err))
    },

    getBlogList (isScrollTo = true) {
      this.spinning = true
      get(`/index/message/blog/list/${this.categoryId}`, this.queryParams)
        .then(res => {
          this.blogList = res.data.list || []
          this.total = res.data.total || 0
          if (isScrollTo) {
            this.onScrollTo()
          }
        })
        .catch(err => console.error('获取博客列表失败：', err))
        .finally(() => {
          this.spinning = false
          this.$nextTick(() => {
            this.checkArrowVisible()
          })
        })
    },

    goToBlogDetail (item) {
      this.$router.push(`/blog/${this.lang}/${item.id}`)
    },

    handlePageChange (pageNum) {
      this.queryParams.pageNum = pageNum
      this.getBlogList()
    },

    handlePageSizeChange (current, size) {
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = size
      this.getBlogList()
    },

    getBlogText (item, type) {
      if (!item) return ''
      return this.lang === 'us' ? item[type] || '' : item[`${type}Vn`] || ''
    },
    onScrollTo () {
      const element = document.getElementsByClassName('nav-wrapper')[0]
      if (!element) return
      let height = 90
      const rect = element.getBoundingClientRect()
      const scrollOptions = {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY - height,
        behavior: 'smooth'
      }
      window.scrollTo(scrollOptions)
    },
  }
}
</script>

<style scoped lang="less">

.blog_content {
  width: 1280px;
  margin: 0 auto 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  font-family: HarmonyOS Sans SC;
}

.blog_title_wrap {
  text-align: center;
  margin-top: 44px;

  .main_title {
    font-weight: bold;
    font-size: 60px;
    color: #111;
    margin: 0;
  }

  .sub_title {
    font-size: 18px;
    color: #585A66;
    margin-top: 5px;
  }
}

.nav-wrapper {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  margin-top: 34px;
  position: relative;
}

.nav-arrow {
  height: 46px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  font-size: 28px;
  color: #333;
  z-index: 10;
  background: #FFFFFF;
  cursor: pointer;
  user-select: none;
  border: none;

  &:hover {
    color: #012169;
  }

  &.left {
    padding-left: 10px;
    padding-right: 15px;
    left: 0;
  }

  &.right {
    padding-left: 15px;
    padding-right: 10px;
    right: 90px;
  }
}

.blog_nav-scroll {
  flex: 1;
  display: flex;
  align-items: center;
  overflow-x: auto;
  flex-wrap: nowrap;
  scroll-behavior: smooth;
  padding: 0 10px;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
}

.nav_item {
  flex-shrink: 0;
  padding: 14px 20px;
  font-size: 16px;
  color: #585A66;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  transition: color 0.3s;

  &::before {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 50%;
    width: 0;
    height: 2px;
    background: #012169;
    transform: translateX(-50%);
    transition: all 0.3s;
  }

  &:hover::before {
    width: 100%;
  }

  &.active {
    color: #012169;

    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      height: 2px;
      background: #012169;
    }
  }
}

.lang_switch {
  flex-shrink: 0;
  margin-left: 12px;

  .lang_bg {
    width: 85px;
    height: 32px;
    background: #e5e7eb;
    border-radius: 16px;
    display: flex;
    align-items: center;
    padding: 0 2px;
  }

  .lang_btn {
    width: 42px;
    height: 28px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
    background: #e5e7eb;

    &.active {
      background: #c5faff;
    }
  }
}

.blog_list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin: 56px 0;
}

.empty_box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 7%;
}

.blog_item {
  display: flex;
  flex-direction: column;
  cursor: pointer;

  .blog_img_wrap {
    width: 396px;
    height: 213px;
    border-radius: 20px;
    overflow: hidden;
    margin-bottom: 25px;
    transition: box-shadow 0.3s ease 0.1s;
    background-color: #f5f7fa; /* 无图片背景 */
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      opacity: 0;
      animation: imgFadeIn 0.8s ease forwards;
    }
  }

  &:hover .blog_img_wrap {
    box-shadow: 0 12px 20px -6px rgba(16, 24, 40, 0.2);
  }

  .blog_title {
    font-weight: bold;
    font-size: 22px;
    color: #222;
    line-height: 30px;
    margin: 0 0 15px;
    min-height: 60px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .blog_desc {
    font-size: 16px;
    color: #585A66;
    line-height: 24px;
    margin: 0 0 30px;
    min-height: 72px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .blog_date {
    font-size: 14px;
    color: #737686;
  }
}

/* 图片从上往下渐变出现动画 */
@keyframes imgFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 10px;

  /deep/ .ant-pagination-item {
    border: none;
    width: 34px;
    height: 34px;
    margin: 0 10px 0 5px;
    line-height: 34px;
    background: #FFFFFF;
    border-radius: 5px;
    text-align: center;

    a {
      font-weight: 400;
      font-size: 16px;
      color: #585A66;
      padding: 0;
    }

    &:hover {
      background: transparent;
    }

    &.ant-pagination-item-active {
      border: 1px solid #012169;
      background: transparent;

      a {
        color: #012169;
        font-weight: 500;
      }
    }
  }

  .pagination-arrow {
    width: 8px;
    height: 14px;
    user-select: none;

    &:hover {
      color: #012169;
    }
  }
}

.bottom-cta {
  margin: 76px 0 75px;
  padding: 36px 0 44px;
  text-align: center;
  background: url(../assets/icon/blog_bg.png) no-repeat;
  background-size: 100% 100%;

  .cta-subtitle {
    font-size: 18px;
    color: #111;
    margin-bottom: 8px;
  }

  .cta-title {
    font-weight: bold;
    font-size: 32px;
    color: #111;
    margin-bottom: 16px;
  }

  .cta-btn {
    display: inline-block;
    width: 189px;
    height: 50px;
    line-height: 50px;
    background: #012169;
    border-radius: 5px;
    font-size: 18px;
    color: #fff;
    transition: background 0.3s;

    &:hover {
      background: #3a4d78;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Blog.vue